// src/pages/technicalAnalysis/utils/fileAnalysisProcessing.js

export const processFileData = (fileData) => {
    return {
      name: fileData.parsed_class.class_name + '.java',
      path: fileData.parsed_class.package,
      type: fileData.class_cluster.type,
      classification: {
        type: fileData.class_cluster.type,
        confidence: Math.round(fileData.class_cluster.confidence_score * 100),
        evidence: fileData.class_cluster.classification_evidence,
        details: fileData.class_cluster.attributes
      },
      metrics: {
        methods: fileData.parsed_class.methods?.length || 0,
        fields: fileData.parsed_class.fields?.length || 0,
        imports: fileData.parsed_class.imports?.length || 0,
        relationships: Object.values(fileData.relationships || {})
          .reduce((acc, rel) => acc + (rel?.length || 0), 0)
      },
      structure: {
        methods: fileData.nodes?.methods || [],
        fields: fileData.nodes?.fields || [],
        annotations: fileData.parsed_class.annotations || []
      },
      parsed_class: fileData.parsed_class || {},
      relationships: fileData.relationships || {},
      data_relationships: fileData.data_relationships || {
        entity_relationships: [],
        transaction_boundaries: [],
        data_ownership: []
      },
      operation_flows: fileData.operation_flows || {
        business_workflows: [],
        transaction_patterns: [],
        api_groupings: []
      },
      rawData: fileData
    };
  };
  
  